import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import * as qs from 'query-string';
import { RouteComponentProps } from 'react-router';
import { Dispatch, connect } from 'react-redux';
import { AxiosError } from 'axios';
import { IBaseResponse, ICenterBase, IConnectToDonorStatus, IDonorConnect, IDonorConnectCounts, IListItem, IMicrositeRecipient } from '@nkr/models/index';
import { AuthRole, ConnectToDonorMilestone, SurveyType } from '@nkr/enums/index';
import {
    IApplicationState, AppActionCreators, IAppState, IDonorConnectListResponse, IDonnorConnectLogListResponse, ICenterContactsResponse,
    DashActionCreators, IDonorConnectLookupDataResponse, IDonnorConnectLogResponse, IDonorConnectNextMilestoneResponse, IFindForTransferResponse,
    ITransferResponse, IDuplicateListResponse, IDuplicateListMentorChangeResponse
} from '@nkr/store/index';
import { ColumnApi, GridApi, GridReadyEvent } from 'ag-grid-community';
import { Badge, Button, Glyphicon, NavItem, OverlayTrigger, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { NavWrapper } from './styles';
import { toast, ToastOptions } from 'react-toastify';
import { donorConnectTabs, ICounselor, ICounts, IDuplicate, tabMap } from './models';
import { downloadFile } from '@nkr/services/download-file';
import Loader from 'react-spinners/ClockLoader';
import Drawer from 'rc-drawer';
import ViewRegistration from './view-registration';
import MobileView from './mobile-view';
import MediaQuery from 'react-responsive';
import informationOverlay from './information';
import Filters from './filters';
import DonorConnectEmailConfirmation from './donor-connect-email-confirmation';
import Grid from './grid';
import Duplicates from './duplicates';
import DonationDateConfirmation from './donation-date-confirmation';
import { GambitType } from '@nkr/models/gambit-type';
import { OrganType } from '@nkr/enums/organ-type';

interface IProps extends RouteComponentProps<{}> { }

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getDonorConnectList: (listType: number, counselorFilter: number, statusFilter: number, showFilter: number, micrositeRecipientId: number, searchFilter: string) => Promise<IDonorConnectListResponse>,
    getLookupData: () => Promise<IDonorConnectLookupDataResponse>,
    getDonorConnectLogEntries: (id: number) => Promise<IDonnorConnectLogListResponse>,
    changeStatus: (id: number, status: number) => Promise<IBaseResponse>,
    changeMentorEducationChoice: (id: number, choice: number) => Promise<IBaseResponse>,
    changeAssignedCounselor: (id: number, userId: number) => Promise<IBaseResponse>,
    changeAssignedCounselorBatch: (list: { id: number, userId: number }[]) => Promise<IDuplicateListMentorChangeResponse>,
    unassignCounselor: (id: number) => Promise<IBaseResponse>,
    updateNextFollowUpDate: (id: number, date: string) => Promise<IBaseResponse>,
    updateDonationDate: (id: number, date: string, type: string, centerId: number) => Promise<IBaseResponse>,
    updateMilestone: (id: number, milestone: ConnectToDonorMilestone) => Promise<IDonorConnectNextMilestoneResponse>,
    submitWorkupSurvey: (id: number, treatment: number, convenience: number, facility: number, commendation: string, improvement: string, completedDate: string) => Promise<IDonorConnectNextMilestoneResponse>,
    submitPreOpSurvey: (id: number, treatment: number, convenience: number, facility: number, commendation: string, improvement: string, completedDate: string) => Promise<IDonorConnectNextMilestoneResponse>,
    submitPostDonationSurvey: (id: number, treatment: number, convenience: number, facility: number, commendation: string, improvement: string, completedDate: string) => Promise<IDonorConnectNextMilestoneResponse>,
    submitPostDonation30DaysSurvey: (id: number, surgeonCare: number, nurseCare: number, painCare: number, caretakerTreatment: number, financialBurden: number, donationCost: number, commendation: string, improvement: string, completedDate: string) => Promise<IDonorConnectNextMilestoneResponse>,
    saveLogEntry: (id: number, dashRegistrationId: number, actionTaken: number, comments: string, isPinned: boolean) => Promise<IDonnorConnectLogResponse>,
    deleteLogEntry: (id: number) => Promise<IBaseResponse>,
    findForTransfer: (centerId: number, email: string, birthDate: string) => Promise<IFindForTransferResponse>,
    transferToExistingRegistration: (transferFromId: number, transferToId: number) => Promise<ITransferResponse>,
    transferToCenter: (registrationId: number, centerId: number) => Promise<ITransferResponse>,
    sendDonorInvite: (donorEmail: string) => Promise<IBaseResponse>,
    getDuplicates: (registrationId: number) => Promise<IDuplicateListResponse>,
    getCenterContacts: (centerId: number) => Promise<ICenterContactsResponse>,
    downloadCenterContacts: (centerId: number) => Promise<ICenterContactsResponse>,
    onHoldStatusReasonChange: (id: number, onHoldStatusReason: string) => Promise<IBaseResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IValidation {
    donationCenter: boolean,
    donationDate: boolean,
    donationType: boolean
}

interface IState {
    list: IDonorConnect[],
    counts: IDonorConnectCounts,
    statusList: IConnectToDonorStatus[],
    mentorEducationChoiceList: IListItem[],
    voucherEducationChoiceList: IListItem[],
    actionList: IListItem[],
    userList: ICounselor[],
    centerList: ICenterBase[],
    closeLoopDonationTypes: IListItem[],
    micrositeRecipientList: IMicrositeRecipient[],
    fetching: boolean,
    currentTab: string,
    userFilter: number,
    statusFilter: number,
    showFilter: number,
    organTypes: OrganType[],
    micrositeRecipient: number,
    searchFilter: string,
    showDonorConnectInvite: boolean,
    validation: IValidation,
    view: {
        show: boolean,
        data: IDonorConnect
    },
    duplicates: {
        show: boolean,
        email: string,
        phoneNumber: string,
        data: IDuplicate[]
    },
    donationDateConfirmation: {
        show: boolean,
        data: IDonorConnect
    },
    gridApi: GridApi,
    columnApi: ColumnApi,
    debouncedValue: string,
    savedDonationDetailIds: number[],
}

class DonorConnect extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        counts: null,
        statusList: [],
        mentorEducationChoiceList: [],
        voucherEducationChoiceList: [],
        actionList: [],
        userList: [],
        centerList: [],
        closeLoopDonationTypes: [],
        micrositeRecipientList: [],
        fetching: false,
        currentTab: donorConnectTabs.TODO,
        userFilter: -1,
        statusFilter: -1,
        showFilter: 0,
        micrositeRecipient: 0,
        searchFilter: '',
        organTypes: [OrganType.Kidney, OrganType.Liver],
        showDonorConnectInvite: false,
        validation: {
            donationCenter: true,
            donationDate: true,
            donationType: true
        },
        view: {
            show: false,
            data: null
        },
        duplicates: {
            show: false,
            email: '',
            phoneNumber: '',
            data: []
        },
        donationDateConfirmation: {
            show: false,
            data: null
        },
        gridApi: null,
        columnApi: null,
        debouncedValue: '',
        savedDonationDetailIds: []
    }


    gridApi: GridApi;
    columnApi: ColumnApi;
    container: HTMLDivElement;
    intervalId: any;

    onGridReady = (e: GridReadyEvent) => {
        e.columnApi.applyColumnState({
            state: [
                {
                    colId: 'connectToDonorNextFollowUpDate',
                    sort: 'asc' // 'asc'
                }
            ]
        });

        e.api.sizeColumnsToFit();

        this.setState({
            gridApi: e.api,
            columnApi: e.columnApi
        });
    }

    saveContainer = (container: HTMLDivElement) => {
        this.container = container;
    };

    getContainer = () => {
        return this.container;
    };

    setUrlParameters = () => {
        let { userFilter, statusFilter, showFilter, searchFilter, micrositeRecipient, organTypes } = this.state;

        let paramList = [];

        if (userFilter >= 0) {
            paramList.push(encodeURI('user=' + userFilter));
        }

        if (statusFilter >= 0) {
            paramList.push('status=' + statusFilter);
        }

        if (showFilter > 0) {
            paramList.push('show=' + showFilter);
        }

        if (searchFilter != '') {
            paramList.push('search=' + searchFilter);
        }

        if (micrositeRecipient > 0) {
            paramList.push('ms=' + micrositeRecipient);
        }

        let params = paramList.join('&');

        let newUrl = '/donor-connect/all?' + params

        window.history.pushState({}, '', newUrl);
    }

    getData = (message: boolean) => {
        let path = this.props.match.path;
        let t = tabMap.find(x => x.url == path);
        let currentTab = t != null ? t.name : donorConnectTabs.TODO;

        if (t == null) {
            t = tabMap.find(x => x.name == currentTab);
        }

        let start = message ? this.props.showLoading('Getting registrations, one moment please...') : Promise.resolve(null);

        let parsed = qs.parse(location.search.length > 0 ? location.search : encodeURI(''), { arrayFormat: 'bracket' });

        var userFilter = parsed.user != null ? parseInt(parsed.user) : this.state.userFilter;
        var statusFilter = parsed.status != null ? parseInt(parsed.status) : this.state.statusFilter;
        var showFilter = parsed.show != null ? parseInt(parsed.show) : this.state.showFilter;
        var micrositeRecipient = parsed.ms != null ? parseInt(parsed.ms) : 0;
        var searchFilter = parsed.search != null ? parsed.search : '';

        start.then(() => {
            this.setState({
                fetching: message == true ? false : true,
                currentTab,
                userFilter,
                statusFilter,
                showFilter,
                searchFilter,
                micrositeRecipient
            }, () => {
                let { userFilter, statusFilter, showFilter, micrositeRecipient, searchFilter } = this.state;

                Promise.all([
                    this.props.getDonorConnectList(t.id, userFilter, statusFilter, showFilter, micrositeRecipient, searchFilter),
                    this.props.getLookupData()
                ])
                    .then(([listResponse, lookupDataResponse]) => {
                        if (listResponse.data.success && lookupDataResponse.data.success) {
                            let { list, counts } = listResponse.data.results;
                            let savedDonationDetailIds = list.filter(x => x.mentorDonationLogged === true).map(x => x.id);
                            let { statusList, actionList, userList, centerList, closeLoopDonationTypes, micrositeRecipientList, mentorEducationChoiceList, voucherEducationChoiceList } = lookupDataResponse.data.results;

                            this.setState({
                                list,
                                counts,
                                statusList,
                                actionList,
                                userList,
                                centerList,
                                mentorEducationChoiceList,
                                voucherEducationChoiceList,
                                closeLoopDonationTypes,
                                micrositeRecipientList,
                                savedDonationDetailIds,
                                fetching: false
                            });
                        }
                    })
                    .catch(error => {
                        toast.error(error?.response?.data ?? 'An error occurred while loading registrations');
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    refreshData = () => {
        let t = tabMap.find(x => x.name == this.state.currentTab);
        let { userFilter, statusFilter, showFilter, micrositeRecipient, searchFilter } = this.state;

        this.props.showLoading('Getting registrations, one moment please...').then(() => {
            this.props.getDonorConnectList(t.id, userFilter, statusFilter, showFilter, micrositeRecipient, searchFilter)
                .then(response => {
                    if (response.data.success) {
                        let { list, counts } = response.data.results;

                        this.setState({
                            list,
                            counts
                        }, () => {
                            this.setUrlParameters();
                        });
                    }
                })
                .catch(error => {
                    toast.error(error?.response?.data ?? 'An error occurred while loading registrations');
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }


    getFilteredList = (): IDonorConnect[] => {
        return this.state.list.filter(x => this.state.organTypes.includes(x.donationTypeId));
    }

    getCounts = (): ICounts => {

        let todo = this.state.counts != null ? this.state.counts.toDoCount : 0;
        let assignedToMe = this.state.counts != null ? this.state.counts.assignedToMeCount : 0;
        let all = this.state.counts != null ? this.state.counts.allCount : 0;

        let unassigned = this.getFilteredList().filter(x => {
            let status = this.state.statusList.find(s => s.id == x.connectToDonorStatusId);
            return (status == null || status.isClosed == false) && x.connectToDonorAssignedUserId == 0;
        }).length;

        return {
            unassigned,
            todo,
            assignedToMe,
            all
        };
    }

    getUserList = () => {
        let list = this.state.userList.map(user => {
            let thisUserCases = this.state.list.filter(x => {
                let status = this.state.statusList.find(s => s.id == x.connectToDonorStatusId);
                return x.connectToDonorAssignedUserId == user.id && status.isClosed == false;
            });

            let newRequestCount = thisUserCases.filter(x => {
                return x.connectToDonorStatusId == 0
            }).length;

            let withinTwoWeeksCount = thisUserCases.filter(x => {
                let cutoff = moment().add(14, 'day').hour(23).minute(59).second(59);

                return x.connectToDonorNextFollowUpDate != '' ?
                    moment(x.connectToDonorNextFollowUpDate, 'MM/DD/YYYY', true).isBefore(cutoff, 'day')
                    :
                    false
            }).length;

            user.activeCaseCount = newRequestCount + withinTwoWeeksCount;

            return user;
        });

        return list;
    }

    getLogAndContactData = async (id: number, centerId: number, recipientCenterId: number, view: boolean) => {
        let list = _.cloneDeep(this.state.list);

        if (view) {
            let data = _.cloneDeep(list.find(x => x.id == id));
            data.centerContacts = data.centerContacts || [];
            data.recipientCenterContacts = data.recipientCenterContacts || [];

            this.setState({
                view: {
                    show: true,
                    data
                }
            });
        }

        Promise.all([
            this.props.getDonorConnectLogEntries(id),
            centerId > 0 ? this.props.getCenterContacts(centerId) : Promise.resolve({ data: { results: [] } }),
            recipientCenterId > 0 ? this.props.getCenterContacts(recipientCenterId) : Promise.resolve({ data: { results: [] } })
        ]).then(([logResponse, contactResponse, recipientContactResponse]) => {
            if (logResponse.data.success && contactResponse.data.results && recipientContactResponse.data.results) {
                list = list.map(x => {
                    if (x.id == id) {
                        x.logs = logResponse.data.results;
                        x.centerContacts = contactResponse.data.results;
                        x.recipientCenterContacts = recipientContactResponse.data.results;
                    }

                    return x;
                });

                let data = _.cloneDeep(list.find(x => x.id == id));

                if (view && this.state.view.show && this.state.view.data != null && this.state.view.data.id == id) {
                    this.setState({
                        list,
                        view: {
                            show: true,
                            data
                        }
                    });
                } else {
                    this.setState({
                        list
                    });
                }
            }
        })
    }

    isDonationDetailsSaved = (id: number) => {
        return this.state.savedDonationDetailIds.includes(id);
    }

    validate = (data: IDonorConnect) => {
        const { mentorDonationDate, mentorDonationTypeId, mentorDonationCenterId } = data;
        const today = moment();

        let validation: IValidation = {
            donationCenter: mentorDonationCenterId > 0,
            donationDate: mentorDonationDate !== '' && mentorDonationDate !== null && !moment(mentorDonationDate, 'MM/DD/YYYY', true).isAfter(today, 'day'),
            donationType: mentorDonationTypeId !== '' && mentorDonationTypeId !== null && mentorDonationTypeId !== 0 && mentorDonationTypeId !== '0',
        };

        return validation;
    }

    getIsRestrictedToAssigned = () => {
        if (this.props.app.user.roles.find(x => x.id == AuthRole.DonorConnectAccessAll) != null) {
            return false;
        }

        return this.props.app.user.roles.find(x => x.id == AuthRole.DonorConnectAccessAssigned) != null;
    }

    componentDidMount = () => {
        this.getData(true);
    }

    handleTabChange = (currentTab: string) => {
        this.setState({
            currentTab
        }, () => {
            this.refreshData();
        });
    }

    handleFilterChange = (property: string, value: any) => {
        if (property == 'statusFilter') {
            this.setState({
                statusFilter: parseInt(value)
            });
        }

        if (property == 'userFilter') {
            this.setState({
                userFilter: parseInt(value)
            });
        }

        if (property == 'showFilter') {
            this.setState({
                showFilter: parseInt(value)
            });
        }

        if (property == 'micrositeRecipient') {
            this.setState({
                micrositeRecipient: parseInt(value)
            });
        }

        if (property == 'searchFilter') {
            this.setState({
                searchFilter: value
            });
        }
    }

    handleSubmitFilters = (reset: boolean) => {
        if (reset) {
            this.setState({
                userFilter: -1,
                statusFilter: -1,
                showFilter: 0,
                searchFilter: ''
            }, () => {
                this.refreshData();
            });
        } else {
            this.refreshData();
        }
    }

    handleStatusChange = (id: number, statusId: number) => {
        // if On Hold status is selected short circuit the process
        // and just show the On Hold Reason field.
        if (statusId === 11) {
            // This convers the grid view
            let newData = { ...this.state.view.data, connectToDonorStatusId: statusId };
            let view = { ...this.state.view, data: newData }

            // This covers the mobile view
            let list = this.state.list.map((item) =>
                item.id === id
                    ? { ...item, connectToDonorStatusId: statusId }
                    : item
            );

            this.setState({
                list,
                view
            });

            return;
        }

        let data = this.state.list.find(x => x.id == id);

        this.props.showLoading('Changing status, one moment please...').then(() => {
            this.props.changeStatus(id, statusId).then(async response => {
                this.props.hideLoading();

                if (response.data.success) {
                    var logResponse = await this.props.getDonorConnectLogEntries(id);

                    let status = this.state.statusList.find(x => x.id == statusId);

                    let list = _.cloneDeep(this.state.list).map(item => {
                        if (item.id == id) {
                            item.connectToDonorStatusId = statusId;
                            item.connectToDonorStatus = status.description;
                            item.logs = logResponse.data.results;
                        }

                        return item;
                    });

                    if (this.state.view.show) {
                        data = list.find(x => x.id == this.state.view.data.id);
                    }

                    this.setState({
                        list,
                        view: { ...this.state.view, data }
                    }, () => {
                        toast.success('Status changed successfully');
                    });
                }
            });
        });
    }

    handleMentorEducationChoiceChange = (id: number, choice: number) => {
        let data = this.state.list.find(x => x.id == id);

        this.props.showLoading('Changing mentor education choice, one moment please...').then(() => {
            this.props.changeMentorEducationChoice(id, choice).then(async response => {
                this.props.hideLoading();

                if (response.data.success) {
                    var logResponse = await this.props.getDonorConnectLogEntries(id);

                    let selectedChoice = this.state.mentorEducationChoiceList.find(x => x.id == choice);

                    let list = _.cloneDeep(this.state.list).map(item => {
                        if (item.id == id) {
                            item.mentorEducationChoiceId = choice;
                            item.mentorEducationChoice = selectedChoice.description;
                            item.logs = logResponse.data.results;
                        }

                        return item;
                    });

                    if (this.state.view.show) {
                        data = list.find(x => x.id == this.state.view.data.id);
                    }

                    this.setState({
                        list,
                        view: { ...this.state.view, data }
                    }, () => {
                        toast.success('Mentor Voucher Choice changed successfully');
                    });
                }
            });
        });
    }

    handleShowDuplicates = (registrationId: number) => {
        let registration = this.state.list.find(x => x.id == registrationId);

        this.props.showLoading('Retrieving duplicates, one moment please...').then(() => {
            this.props.getDuplicates(registrationId)
                .then(response => {
                    if (response.data.success) {
                        this.setState({
                            duplicates: {
                                show: true,
                                email: registration.email,
                                phoneNumber: registration.phoneNumber,
                                data: response.data.results.map(x => ({ ...x, newMentorId: x.connectToDonorAssignedUserId, changed: false }))
                            }
                        }, () => {
                            this.props.hideLoading();
                        });
                    }
                })
                .catch(error => {
                    this.props.hideLoading();
                });
        })
    }

    handleMentorChange = (id: number, userId: number) => {
        let data = _.cloneDeep(this.state.duplicates.data).map(x => {
            if (x.id == id) {
                x.newMentorId = userId;
                x.changed = x.newMentorId != x.connectToDonorAssignedUserId;
            }

            return x;
        });

        this.setState({
            duplicates: { ...this.state.duplicates, data }
        });
    }

    handleUpdateMentorsForDuplicates = () => {
        let list = this.state.duplicates.data.filter(x => x.changed).map(x => ({ id: x.id, userId: x.newMentorId }));

        this.setState({
            duplicates: {
                show: false,
                email: '',
                phoneNumber: '',
                data: []
            }
        }, () => {
            this.props.showLoading('Updating mentors, one moment please...').then(response => {
                this.props.changeAssignedCounselorBatch(list).then(response => {
                    if (response.data.success) {
                        if (response.data.results.length == 0) {
                            toast.success('Mentors updated successfully');
                        } else {
                            toast.warn('Some of the records could not be updated');
                        }

                        this.props.hideLoading();
                    }
                });
            });
        });
    }

    handleCancelDuplicates = () => {
        this.setState({
            duplicates: {
                show: false,
                email: '',
                phoneNumber: '',
                data: []
            }
        });
    }

    handleAssignedCounselorChange = (id: number, userId: number) => {
        let data = this.state.list.find(x => x.id == id);

        if (userId > 0) {
            this.props.showLoading('Changing assigned mentor, one moment please...').then(() => {
                this.props.changeAssignedCounselor(id, userId)
                    .then(async response => {
                        if (response.data.success) {
                            let logResponse = await this.props.getDonorConnectLogEntries(id);
                            let user = this.state.userList.find(x => id == userId);

                            let userList = this.state.userList.map(user => {
                                if (user.id == userId) {
                                    user.activeCaseCount += 1;
                                    user.assignedTodayCount += 1;
                                }
                                return user;
                            });

                            let list = _.cloneDeep(this.state.list).map(item => {
                                if (item.id == id) {
                                    item.connectToDonorAssignedUserId = userId;
                                    item.connectToDonorAssigndUser = user;
                                    item.logs = logResponse.data.results;
                                }

                                return item;
                            });

                            if (this.state.view.show) {
                                data = list.find(x => x.id == this.state.view.data.id);
                            }

                            this.setState({
                                list,
                                userList,
                                view: { ...this.state.view, data }
                            }, () => {
                                toast.success('Assigned mentor changed successfully');
                            });
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        } else {
            this.props.showLoading('Unassigning counselor, one moment please...').then(() => {
                this.props.unassignCounselor(id)
                    .then(async response => {
                        if (response.data.success) {
                            var logResponse = await this.props.getDonorConnectLogEntries(id);

                            let list = _.cloneDeep(this.state.list).map(item => {
                                if (item.id == id) {
                                    item.connectToDonorAssignedUserId = 0;
                                    item.connectToDonorAssigndUser = null;
                                    item.logs = logResponse.data.results;
                                }

                                return item;
                            });

                            if (this.state.view.show) {
                                data = list.find(x => x.id == this.state.view.data.id);
                            }

                            this.setState({
                                list,
                                view: { ...this.state.view, data }
                            }, () => {
                                toast.success('Counselor unassigned successfully');
                            });
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        }
    }

    handleNextFollowUpDateChange = (date: string) => {
        let data = _.cloneDeep(this.state.view.data);
        data.connectToDonorNextFollowUpDate = date;

        this.setState({
            view: {
                ...this.state.view,
                data
            }
        });
    }

    handleDonationDateChange = (date: string) => {
        let data = _.cloneDeep(this.state.view.data);
        data.mentorDonationDate = date;

        this.setState({
            view: {
                ...this.state.view,
                data
            }
        });
    }

    handleDonationDateChangeMobile = (id: number, date: string) => {
        let list = _.cloneDeep(this.state.list).map(x => {
            if (x.id == id) {
                x.mentorDonationDate = date;
            }

            return x;
        });

        this.setState({
            list
        });
    }

    handleDonationCenterChange = (centerId: string) => {
        let data = _.cloneDeep(this.state.view.data);
        data.mentorDonationCenterId = parseInt(centerId, 10);

        this.setState({
            view: {
                ...this.state.view,
                data
            }
        });
    }

    handleDonationCenterChangeMobile = (id: number, centerId: string) => {
        let list = _.cloneDeep(this.state.list).map(x => {
            if (x.id == id) {
                x.mentorDonationCenterId = parseInt(centerId, 10);
            }

            return x;
        });

        this.setState({
            list
        });
    }

    handleDonationTypeChange = (type: string) => {
        let data = _.cloneDeep(this.state.view.data);
        data.mentorDonationTypeId = type;

        this.setState({
            view: {
                ...this.state.view,
                data
            }
        });
    }

    handleDonationTypeChangeMobile = (id: number, donationTypeId: string) => {
        let list = _.cloneDeep(this.state.list).map(x => {
            if (x.id == id) {
                x.mentorDonationTypeId = donationTypeId ? parseInt(donationTypeId, 10) : null;
            }

            return x;
        });

        this.setState({
            list
        });
    }

    handleSaveDonationDate = () => {
        let { id, mentorDonationDate, mentorDonationTypeId, mentorDonationCenterId } = this.state.donationDateConfirmation.data;

        this.updateDonationDate(id, mentorDonationDate, mentorDonationTypeId, mentorDonationCenterId);
    }

    handleSaveDonationDetails = (id: number) => {
        let validation = this.validate(this.state.view.data);

        this.setState({
            validation
        }, () => {
            let { donationCenter, donationDate, donationType } = this.state.validation;
            let valid = donationCenter && donationDate && donationType;

            if (valid) {
                let data = _.cloneDeep(this.state.view.data);

                this.setState({
                    donationDateConfirmation: {
                        show: true,
                        data
                    }
                });

            }
        })
    }

    handleSaveDonationDetailsMobile = (id: number) => {
        let validation = this.validate(this.state.list.find(x => x.id == id));

        this.setState({
            validation
        }, () => {
            let { donationCenter, donationDate, donationType } = this.state.validation;
            let valid = donationCenter && donationDate && donationType;

            if (valid) {
                let data = _.cloneDeep(this.state.list.find(x => x.id == id));

                this.setState({
                    donationDateConfirmation: {
                        show: true,
                        data
                    }
                });
            }
        })
    }

    handleNextFollowUpDateChangeMobile = (id: number, date: string) => {
        let list = _.cloneDeep(this.state.list).map(x => {
            if (x.id == id) {
                x.connectToDonorNextFollowUpDate = date;
            }

            return x;
        });

        this.setState({
            list
        });
    }

    handleUpdateNextFollowupDateMobile = (id: number) => {
        let item = this.state.list.find(x => x.id == id);
        let date = item != null ? item.connectToDonorNextFollowUpDate : '';

        this.updateNextFollowUpDate(id, date);
    }

    handleUpdateNextFollowUpDate = (id: number) => {
        let { connectToDonorNextFollowUpDate } = this.state.view.data;
        this.updateNextFollowUpDate(id, connectToDonorNextFollowUpDate);
    }

    handleRemoveNextFollowUpDate = (id: number) => {
        let data = _.cloneDeep(this.state.view.data);
        data.connectToDonorNextFollowUpDate = '';

        this.setState({
            view: {
                ...this.state.view,
                data
            }
        }, () => {
            this.removeNextFollowUpDate(id);
        });
    }

    handleViewRegistration = async (id: number, centerId: number, recipientCenterId: number) => {
        this.getLogAndContactData(id, centerId, recipientCenterId, true);
    }

    handleCancelView = () => {
        this.setState({
            view: {
                show: false,
                data: null
            }
        });
    }

    handleMentorEmailSent = () => {
        const { data } = this.state.view;

        if (!this.state.view.show || data == null) {
            return;
        }

        this.getLogAndContactData(data.id, data.centerId, data.recipientCenterId, true);
    }

    handleSaveLogEntry = (id: number, dashRegistrationId: number, actionTaken: number, comments: string, isPinned: boolean) => {
        let message = id == 0 ? 'Adding log entry, one moment please...' : 'Updating log entry, one moment please...';

        this.props.showLoading(message).then(() => {
            this.props.saveLogEntry(id, dashRegistrationId, actionTaken, comments, isPinned)
                .then(response => {
                    let list = _.cloneDeep(this.state.list).map(item => {
                        if (item.id == dashRegistrationId) {
                            if (id == 0) {
                                item.logs.push(response.data.results);
                            } else {
                                item.logs = item.logs.map(logItem => {
                                    if (logItem.id == id) {
                                        return response.data.results;
                                    }
                                    return logItem;
                                })
                            }
                        }

                        return item;
                    });

                    let data = list.find(x => x.id == dashRegistrationId);

                    this.setState({
                        list,
                        view: { show: true, data }
                    }, () => {
                        toast.success(id == 0 ? 'Log entry added successfully' : 'Log entry updated successfully');
                    });
                })
                .catch((error: AxiosError) => {
                })
                .finally(() => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    handleDeleteLogEntry = (id: number, dashRegistrationId: number) => {
        this.props.showLoading('Deleting log entry, one moment please...').then(() => {
            this.props.deleteLogEntry(id)
                .then(response => {
                    if (response.data.success) {
                        let list = _.cloneDeep(this.state.list).map(item => {
                            if (item.id == dashRegistrationId) {
                                item.logs = item.logs.filter(logItem => logItem.id != id);
                            }

                            return item;
                        });

                        let data = list.find(x => x.id == dashRegistrationId);

                        this.setState({
                            list,
                            view: { show: true, data }
                        }, () => {
                            toast.success('Log entry delete successfully');
                        });
                    }
                })
                .catch((error: AxiosError) => {
                })
                .finally(() => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    updateDonationDate = (id: number, date: string, type: string, centerId: number) => {
        this.props.showLoading('Updating donation date, one moment please...').then(() => {
            this.props.updateDonationDate(id, date, type, centerId)
                .then(async response => {
                    if (response.data.success) {
                        var logResponse = await this.props.getDonorConnectLogEntries(id);

                        let list = _.cloneDeep(this.state.list).map(item => {
                            if (item.id == id) {
                                item.mentorDonationDate = date;
                                item.mentorDonationTypeId = type;
                                item.mentorDonationCenterId = centerId;
                                item.mentorDonationLogged = true;
                                item.logs = logResponse.data.results;
                            }

                            return item;
                        });

                        let data = this.state.view.show ? list.find(x => x.id == id) : this.state.view.data;
                        let savedDonationDetailIds = this.state.savedDonationDetailIds.includes(id)
                            ? this.state.savedDonationDetailIds
                            : [...this.state.savedDonationDetailIds, id];

                        this.setState({
                            list,
                            savedDonationDetailIds,
                            view: { ...this.state.view, data }
                        }, () => {
                            toast.success('Donation details changed successfully');
                            this.setState({
                                donationDateConfirmation: {
                                    show: false,
                                    data: null
                                }
                            });
                        });
                    }
                    else {
                        toast.error(response.data.message ?? "An unexpected exception occurred", { autoClose: false });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    updateNextFollowUpDate = (id: number, date: string) => {
        this.props.showLoading('Changing next follow-up date, one moment please...').then(() => {
            let nextFollowUp = moment(date).format("MM/DD/YYYY");

            this.props.updateNextFollowUpDate(id, nextFollowUp)
                .then(async response => {
                    if (response.data.success) {
                        var logResponse = await this.props.getDonorConnectLogEntries(id);

                        let list = _.cloneDeep(this.state.list).map(item => {
                            if (item.id == id) {
                                item.connectToDonorNextFollowUpDate = date;
                                item.logs = logResponse.data.results;
                            }

                            return item;
                        });

                        this.setState({
                            list,
                        }, () => {
                            toast.success('Next follow-up date changed successfully');
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    removeNextFollowUpDate = (id: number) => {
        this.props.showLoading('Removing next follow-up date, one moment please...').then(() => {
            this.props.updateNextFollowUpDate(id, '')
                .then(async response => {
                    if (response.data.success) {
                        var logResponse = await this.props.getDonorConnectLogEntries(id);

                        let list = _.cloneDeep(this.state.list).map(item => {
                            if (item.id == id) {
                                item.connectToDonorNextFollowUpDate = moment().add(2, 'day').format('MM/DD/YYYY');
                                item.logs = logResponse.data.results;
                            }

                            return item;
                        });

                        this.setState({
                            list
                        }, () => {
                            toast.success('Next follow-up date removed successfully');
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleNextMilestone = (id: number, milestone: ConnectToDonorMilestone) => {
        this.props.showLoading('Updating milestone, one moment please...').then(() => {
            this.props.updateMilestone(id, milestone).then(async response => {
                if (response.data.success) {
                    let { connectToDonorMilestone, connectToDonorMilestoneDescription, connectToDonorNextMilestone, connectToDonorNextMilestoneDescription, connectToDonorMilestoneCanProgress } = response.data.results;

                    this.updateRegistration(id, connectToDonorMilestone, connectToDonorMilestoneDescription, connectToDonorNextMilestone, connectToDonorNextMilestoneDescription, connectToDonorMilestoneCanProgress, 'Milestone updated successfully');
                }
            });
        });
    }

    handleSubmitWorkupSurvey = (id: number, treatment: number, convenience: number, facility: number, commendation: string, improvement: string, completedDate: string) => {
        this.props.showLoading('Saving workup survey, one moment please...').then(() => {
            this.props.submitWorkupSurvey(id, treatment, convenience, facility, commendation, improvement, completedDate)
                .then(async response => {
                    if (response.data.success) {
                        let { connectToDonorNextMilestone } = response.data.results;

                        this.handleNextMilestone(id, connectToDonorNextMilestone)
                        toast.success('Workup survey saved successfully');
                    } else {
                        toast.error("Unable to save survey.  Survey was already complete.");
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleSubmitPreOpSurvey = (id: number, treatment: number, convenience: number, facility: number, commendation: string, improvement: string, completedDate: string) => {
        this.props.showLoading('Saving pre-op survey, one moment please...').then(() => {
            this.props.submitPreOpSurvey(id, treatment, convenience, facility, commendation, improvement, completedDate)
                .then(async response => {
                    if (response.data.success) {
                        let { connectToDonorNextMilestone } = response.data.results;

                        this.handleNextMilestone(id, connectToDonorNextMilestone)
                        toast.success('Pre-Op survey saved successfully');
                    } else {
                        toast.error("Unable to save survey.  Survey was already complete.");
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleSubmitPostDonationSurvey = (id: number, treatment: number, convenience: number, facility: number, commendation: string, improvement: string, completedDate: string) => {
        this.props.showLoading('Saving post donation survey, one moment please...').then(() => {
            this.props.submitPostDonationSurvey(id, treatment, convenience, facility, commendation, improvement, completedDate)
                .then(async response => {
                    if (response.data.success) {
                        let { connectToDonorNextMilestone } = response.data.results;

                        this.handleNextMilestone(id, connectToDonorNextMilestone)
                        toast.success('Post donation survey saved successfully');
                    } else {
                        toast.error("Unable to save survey.  Survey was already complete.");
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleSubmitPostDonation30DaysSurvey = (id: number, surgeonCare: number, nurseCare: number, painCare: number, caretakerTreatment: number, financialBurden: number, donationCost: number, commendation: string, improvement: string, completedDate: string) => {
        this.props.showLoading('Saving 30 day post donation final survey, one moment please...').then(() => {
            this.props.submitPostDonation30DaysSurvey(id, surgeonCare, nurseCare, painCare, caretakerTreatment, financialBurden, donationCost, commendation, improvement, completedDate)
                .then(async response => {
                    if (response.data.success) {
                        let { connectToDonorNextMilestone } = response.data.results;

                        this.handleNextMilestone(id, connectToDonorNextMilestone)
                        toast.success('30 day post donation final survey saved successfully');
                    } else {
                        toast.error("Unable to save survey.  Survey was already complete.");
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleFindForTransfer = (centerId: number, email: string, birthDate: string) => {
        return this.props.showLoading('Searching, one moment please...').then(() => {
            return this.props.findForTransfer(centerId, email, birthDate).then(response => {
                this.props.hideLoading();

                return response;
            });
        });
    }

    handleRequestTransfer = (id: number, centerId: number) => {
        this.props.showLoading('Requesting transfer, one moment please...').then(() => {
            this.props.transferToCenter(id, centerId)
                .then(response => {
                    if (response.data.success) {
                        let list = _.cloneDeep(this.state.list).map(item => {
                            if (item.id == id) {
                                return response.data.results;
                            }

                            return item;
                        });

                        let view = _.cloneDeep(this.state.view);
                        view.data = response.data.results;

                        this.setState({
                            list,
                            view
                        }, () => {
                            toast.success('Transfer completed successfully');
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleCompleteTransfer = (id: number, existingId: number) => {
        this.props.showLoading('Requesting transfer, one moment please...').then(() => {
            this.props.transferToExistingRegistration(id, existingId)
                .then(response => {
                    if (response.data.success) {
                        let list = _.cloneDeep(this.state.list).map(item => {
                            if (item.id == id) {
                                return response.data.results;
                            }

                            return item;
                        });

                        let view = _.cloneDeep(this.state.view);
                        view.data = response.data.results;

                        this.setState({
                            list,
                            view
                        }, () => {
                            // const options = {
                            //     onOpen: props => console.log(props.foo),
                            //     onClose: props => console.log(props.foo),
                            //     autoClose: 6000,
                            //     //closeButton: FontAwesomeCloseButton,
                            //     type: toast.TYPE.INFO,
                            //     hideProgressBar: false,
                            //     position: toast.POSITION.TOP_LEFT,
                            //     pauseOnHover: true,
                            //     //transition: MyCustomTransition,
                            //     progress: 0.2
                            //     // and so on ...
                            // };

                            toast.success('Transfer completed successfully.'
                                + 'Please inform the donor that their registration was transferred '
                                + 'to {CenterName} through the National Kidney Registry so that '
                                + 'e-mails from the NKR will not come as a surprise', { autoClose: false });
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleInviteDonor = () => {
        this.setState({
            showDonorConnectInvite: true
        });
    }

    handleRequestEmail = (donorEmail: string) => {
        this.setState({
            showDonorConnectInvite: false
        }, () => {
            this.props.showLoading('Sending Donor Mentor Invite, one moment please...').then(() => {
                this.props.sendDonorInvite(donorEmail)
                    .then(response => {

                        if (response.data.success) {
                            toast.success('Invite sent successfully');
                        }
                        else if (!response.data.success) {
                            toast.error(response.data.message);
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleCancelInviteView = () => {
        this.setState({
            showDonorConnectInvite: false
        });
    }

    handleCancelDonationDateConfirm = () => {
        this.setState({
            donationDateConfirmation: {
                show: false,
                data: null
            }
        });
    };

    handleDownloadCenterContacts = (centerId: number) => {
        this.props.downloadCenterContacts(centerId)
            .then((response: any) => {
                downloadFile(response.data, `contact-list-export-results.csv`, 'text/csv');
            });
    }

    updateRegistration = async (id: number, connectToDonorMilestone: ConnectToDonorMilestone, connectToDonorMilestoneDescription: string, connectToDonorNextMilestone: ConnectToDonorMilestone, connectToDonorNextMilestoneDescription: string, connectToDonorMilestoneCanProgress: boolean, message: string) => {
        var logResponse = await this.props.getDonorConnectLogEntries(id);

        let list = _.cloneDeep(this.state.list).map(item => {
            if (item.id == id) {
                item.connectToDonorMilestone = connectToDonorMilestone;
                item.connectToDonorMilestoneDescription = connectToDonorMilestoneDescription;
                item.connectToDonorNextMilestone = connectToDonorNextMilestone;
                item.connectToDonorNextMilestoneDescription = connectToDonorNextMilestoneDescription;
                item.connectToDonorMilestoneCanProgress = connectToDonorMilestoneCanProgress;
                item.logs = logResponse.data.results;
            }

            return item;
        });

        let data = list.find(x => x.id == id);

        this.setState({
            list,
            view: { show: true, data }
        }, () => {
            this.props.hideLoading();
            toast.success(message);
        });
    }

    onHoldStatusReasonChange = async (id: number, onHoldStatusReason: string) => {

        let data = this.state.list.find(x => x.id == id);

        this.props.showLoading('Changing status, one moment please...').then(() => {
            this.props.onHoldStatusReasonChange(id, onHoldStatusReason).then(async response => {
                this.props.hideLoading();

                if (response.data.success) {
                    var logResponse = await this.props.getDonorConnectLogEntries(id);

                    let status = this.state.statusList.find(x => x.id == 11);

                    let updatedList = _.cloneDeep(this.state.list).map(item => {
                        if (item.id == id) {
                            item.connectToDonorStatusId = 11;
                            item.connectToDonorStatus = status.description;
                            if (item.dashGambitData.length <= 0) {
                                // it's empty add a new entry
                                item.dashGambitData = [
                                    {
                                        id: id,
                                        gambitType: GambitType.DonotIntakeOnHoldReason_ConnectToDonorStatus,
                                        collectedData: onHoldStatusReason,
                                        insertedDate: null,
                                        updatedDate: null
                                    }
                                ]
                            } else {
                                item.dashGambitData = item.dashGambitData.map((gambitData) =>
                                    gambitData.gambitType === GambitType.DonotIntakeOnHoldReason_ConnectToDonorStatus
                                        ? { ...gambitData, collectedData: onHoldStatusReason }
                                        : gambitData
                                );
                            }
                            item.logs = logResponse.data.results;
                        }

                        return item;
                    });

                    if (this.state.view.show) {
                        data = updatedList.find(x => x.id == this.state.view.data.id);
                    }

                    this.setState({
                        list: updatedList,
                        view: { ...this.state.view, data }
                    }, () => {
                        toast.success('Status changed successfully');
                    });
                }
            });
        });
    }

    changeOrganType = (values: OrganType | OrganType[]) => {
        let safeValues = Array.isArray(values) ? values : [values];
        if (safeValues.length == 0) return;
        this.setState({ organTypes: safeValues });
    }

    render = () => {
        const list = this.getFilteredList();
        const counts = this.getCounts();
        const userList = _.sortBy(this.state.userList, item => item.lastName);
        const isRestrictedToAssigned = this.getIsRestrictedToAssigned();
        const organValue = this.state.organTypes.length == 2 ? -1 : this.state.organTypes[0];


        return (
            <>
                <MediaQuery minWidth={1024}>
                    <div ref={this.saveContainer} />
                    <div className='container-fluid'>
                        <div className='row' style={{ marginTop: 0, marginBottom: 30 }}>
                            <div className='col-xs-12 col-lg-12'>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                                    <h1 style={{ margin: 0 }}>Donor Mentor DASH Registrations</h1>

                                    <div style={{ display: 'flex' }}>
                                        {this.state.fetching && (
                                            <>
                                                <div style={{ marginRight: 5 }}>Fetching registrations...</div>
                                                <Loader
                                                    size={20}
                                                    color={'#a1a1a1'}
                                                />
                                            </>
                                        )}
                                    </div>
                                    <div style={{ fontSize: 18 }}>
                                        <OverlayTrigger trigger='click' placement='left' rootClose overlay={informationOverlay}><Glyphicon glyph='info-sign' /></OverlayTrigger>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={{ marginBottom: 10, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <NavWrapper bsStyle='tabs' verticalAlign='center' minTabWidth={105} activeHref={this.props.match.path} onSelect={(eventKey: any) => this.handleTabChange(eventKey)}>
                                {!isRestrictedToAssigned && (
                                    <NavItem href='/donor-connect/unassigned'>UNASSIGNED&nbsp;<Badge>{counts.unassigned}</Badge></NavItem>
                                )}
                                <NavItem href='/donor-connect/to-do'>TO DO&nbsp;<Badge>{counts.todo}</Badge></NavItem>
                                <NavItem href='/donor-connect/assigned-to-me'>ASSIGNED TO ME&nbsp;<Badge>{counts.assignedToMe}</Badge></NavItem>
                                <NavItem href='/donor-connect/all'>ALL&nbsp;<Badge>{counts.all}</Badge></NavItem>
                            </NavWrapper>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <span style={{ fontWeight: 500, marginRight: 5 }}>Organ:</span>
                                <div className="btn-group" data-toggle="buttons" style={{ marginRight: 25 }}>
                                    <ToggleButtonGroup type='radio' name='organs' value={organValue}>
                                        <ToggleButton value={-1} onChange={() => this.changeOrganType([OrganType.Kidney, OrganType.Liver])}
                                            className={this.state.organTypes.length == 2 ? 'btn-primary btn-md' : 'btn-md'}>All</ToggleButton>
                                        <ToggleButton value={OrganType.Kidney} onChange={() => this.changeOrganType(OrganType.Kidney)}
                                            className={this.state.organTypes.length == 1 && this.state.organTypes.includes(OrganType.Kidney) ? 'btn-primary btn-md' : 'btn-md'}>Kidney</ToggleButton>
                                        <ToggleButton value={OrganType.Liver} onChange={() => this.changeOrganType(OrganType.Liver)}
                                            className={this.state.organTypes.length == 1 && this.state.organTypes.includes(OrganType.Liver) ? 'btn-primary btn-md' : 'btn-md'}>Liver</ToggleButton>
                                    </ToggleButtonGroup>
                                </div>
                                <Button bsStyle='success' style={{ whiteSpace: 'normal' }} onClick={this.handleInviteDonor}>Invite Existing Donor</Button>
                            </div>
                        </div>

                        {this.state.currentTab == donorConnectTabs.ALL && (
                            <Filters
                                userFilter={this.state.userFilter}
                                statusFilter={this.state.statusFilter}
                                showFilter={this.state.showFilter}
                                micrositeRecipient={this.state.micrositeRecipient}
                                searchFilter={this.state.searchFilter}
                                userList={userList}
                                statusList={this.state.statusList}
                                micrositeRecipientList={this.state.micrositeRecipientList}
                                isRestrictedToAssigned={isRestrictedToAssigned}
                                onChange={this.handleFilterChange}
                                onSubmit={this.handleSubmitFilters}
                            />
                        )}

                        <div className='row'>
                            <div className='col-xs-12 col-lg-12'>
                                <Grid
                                    list={list}
                                    statusList={this.state.statusList}
                                    userList={this.state.userList}
                                    user={this.props.app.user}
                                    currentTab={this.state.currentTab}
                                    onViewRegistration={this.handleViewRegistration}
                                    onStatusChange={this.handleStatusChange}
                                    onAssignedCounselorChange={this.handleAssignedCounselorChange}
                                    onShowDuplicates={this.handleShowDuplicates}
                                />
                            </div>
                        </div>
                    </div>

                    <Drawer
                        width="40vw"
                        // handler={false}
                        placement="right"
                        getContainer={this.getContainer}
                        open={this.state.view.show}
                    >
                        <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                            <div style={{ padding: 10 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                                    <h3 style={{ margin: 0 }}>DASH Registration</h3>
                                    <Button bsStyle='link' bsSize='sm' onClick={this.handleCancelView}><Glyphicon glyph='remove' /></Button>
                                </div>

                                <ViewRegistration
                                    isOpen={this.state.view.show}
                                    data={this.state.view.data}
                                    user={this.props.app.user}
                                    statusList={this.state.statusList}
                                    mentorEducationChoiceList={this.state.mentorEducationChoiceList}
                                    actionList={this.state.actionList}
                                    userList={this.state.userList}
                                    centerList={this.state.centerList}
                                    closeLoopDonationTypes={this.state.closeLoopDonationTypes}
                                    donationDetailsSaved={this.state.view.data != null && this.isDonationDetailsSaved(this.state.view.data.id)}
                                    onStatusChange={this.handleStatusChange}
                                    onMentorEducationChoiceChange={this.handleMentorEducationChoiceChange}
                                    onCounselorChange={this.handleAssignedCounselorChange}
                                    onNextFollowUpDateChange={this.handleNextFollowUpDateChange}
                                    onDonationDateChange={this.handleDonationDateChange}
                                    onDonationCenterChange={this.handleDonationCenterChange}
                                    onDonationTypeChange={this.handleDonationTypeChange}
                                    onDonationUpdateClick={this.handleSaveDonationDetails}
                                    onUpdateNextFollowUpDate={this.handleUpdateNextFollowUpDate}
                                    onRemoveNextFollowUpDate={this.handleRemoveNextFollowUpDate}
                                    onSaveLogEntry={this.handleSaveLogEntry}
                                    onDeleteLogEntry={this.handleDeleteLogEntry}
                                    onNextMilestone={this.handleNextMilestone}
                                    onSubmitWorkupSurvey={this.handleSubmitWorkupSurvey}
                                    onSubmitPreOpSurvey={this.handleSubmitPreOpSurvey}
                                    onSubmitPostDonationSurvey={this.handleSubmitPostDonationSurvey}
                                    onSubmitPostDonation30DaysSurvey={this.handleSubmitPostDonation30DaysSurvey}
                                    onFindForTransfer={this.handleFindForTransfer}
                                    onRequestTransfer={this.handleRequestTransfer}
                                    onCompleteTransfer={this.handleCompleteTransfer}
                                    onDownloadCenterContacts={this.handleDownloadCenterContacts}
                                    onHoldStatusReasonChange={this.onHoldStatusReasonChange}
                                    onMentorEmailSent={this.handleMentorEmailSent}
                                />
                            </div>

                            <div className='text-center bg-info'>
                                <Button bsStyle='link' block onClick={this.handleCancelView}>Close This View</Button>
                            </div>
                        </div>
                    </Drawer>
                </MediaQuery>

                <MediaQuery maxWidth={1023}>
                    <MobileView
                        list={list}
                        user={this.props.app.user}
                        currentTab={this.state.currentTab}
                        statusFilter={this.state.statusFilter}
                        counts={counts}
                        statusList={this.state.statusList}
                        userList={this.state.userList}
                        centerList={this.state.centerList}
                        actionList={this.state.actionList}
                        mentorEducationChoiceList={this.state.mentorEducationChoiceList}
                        closeLoopDonationTypes={this.state.closeLoopDonationTypes}
                        savedDonationDetailIds={this.state.savedDonationDetailIds}
                        onTabChange={this.handleTabChange}
                        onStatusChange={this.handleStatusChange}
                        onAssignedCounselorChange={this.handleAssignedCounselorChange}
                        onNextFollowUpDateChange={this.handleNextFollowUpDateChangeMobile}
                        onUpdateNextFollowupDate={this.handleUpdateNextFollowupDateMobile}
                        onRemoveNextFollowUpDate={this.handleRemoveNextFollowUpDate}
                        onNextMilestone={this.handleNextMilestone}
                        onSubmitWorkupSurvey={this.handleSubmitWorkupSurvey}
                        onSubmitPreOpSurvey={this.handleSubmitPreOpSurvey}
                        onSubmitPostDonationSurvey={this.handleSubmitPostDonationSurvey}
                        onSubmitPostDonation30DaysSurvey={this.handleSubmitPostDonation30DaysSurvey}
                        onSaveLogEntry={this.handleSaveLogEntry}
                        onDeleteLogEntry={this.handleDeleteLogEntry}
                        onGetDonorConnectLogEntries={this.getLogAndContactData}
                        onFindForTransfer={this.handleFindForTransfer}
                        onRequestTransfer={this.handleRequestTransfer}
                        onCompleteTransfer={this.handleCompleteTransfer}
                        onMentorEducationChoiceChange={this.handleMentorEducationChoiceChange}
                        onDonationDateChange={this.handleDonationDateChangeMobile}
                        onDonationCenterChange={this.handleDonationCenterChangeMobile}
                        onDonationTypeChange={this.handleDonationTypeChangeMobile}
                        onDonationUpdateClick={this.handleSaveDonationDetailsMobile}
                        onFilterChange={this.handleFilterChange}
                        onFilterSubmit={this.handleSubmitFilters}
                        onHoldStatusReasonChange={this.onHoldStatusReasonChange}
                    />
                </MediaQuery>

                <DonorConnectEmailConfirmation
                    show={this.state.showDonorConnectInvite}
                    container={this}
                    startingEmail=''
                    onSendEmail={this.handleRequestEmail}
                    onCancel={this.handleCancelInviteView}
                />

                <Duplicates
                    show={this.state.duplicates.show}
                    email={this.state.duplicates.email}
                    phoneNumber={this.state.duplicates.phoneNumber}
                    data={this.state.duplicates.data}
                    roles={this.props.app.user.roles}
                    mentorList={this.state.userList}
                    container={this}
                    onMentorChange={this.handleMentorChange}
                    onUpdate={this.handleUpdateMentorsForDuplicates}
                    onClose={this.handleCancelDuplicates}
                />

                <DonationDateConfirmation
                    show={this.state.donationDateConfirmation.show}
                    data={this.state.donationDateConfirmation.data}
                    onConfirm={this.handleSaveDonationDate}
                    onCancel={this.handleCancelDonationDateConfirm}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getDonorConnectList: (listType, counselorFilter, statusFilter, showFilter, micrositeRecipientId, searchFilter) => {
            return dispatch(DashActionCreators.getDonorConnectList(listType, counselorFilter, statusFilter, showFilter, micrositeRecipientId, searchFilter));
        },
        getLookupData: () => {
            return dispatch(DashActionCreators.getDonorConnectLookupData());
        },
        getDonorConnectLogEntries: (id) => {
            return dispatch(DashActionCreators.getDonorConnectLogEntries(id));
        },
        changeStatus: (id, status) => {
            return dispatch(DashActionCreators.changeStatus(id, status));
        },
        changeMentorEducationChoice: (id, choice) => {
            return dispatch(DashActionCreators.changeMentorEducationChoice(id, choice));
        },
        changeAssignedCounselor: (id, userId) => {
            return dispatch(DashActionCreators.changedAssignedCounselor(id, userId));
        },
        changeAssignedCounselorBatch: (list) => {
            return dispatch(DashActionCreators.changedAssignedCounselorBatch(list));
        },
        unassignCounselor: (id) => {
            return dispatch(DashActionCreators.unassignCounselor(id));
        },
        updateDonationDate: (id, date, type, centerId) => {
            return dispatch(DashActionCreators.updateDonationDate(id, date, type, centerId));
        },
        updateNextFollowUpDate: (id, date) => {
            return dispatch(DashActionCreators.updateNextFollowUpDate(id, date));
        },
        updateMilestone: (id, milestone) => {
            return dispatch(DashActionCreators.updateMilestone(id, milestone));
        },
        submitWorkupSurvey: (id, treatment, convenience, facility, commendation, improvement, completedDate) => {
            return dispatch(DashActionCreators.submitSurvey(id, treatment, convenience, facility, null, null, null, null, null, null, commendation, improvement, completedDate, SurveyType.Workup));
        },
        submitPreOpSurvey: (id, treatment, convenience, facility, commendation, improvement, completedDate) => {
            return dispatch(DashActionCreators.submitSurvey(id, treatment, convenience, facility, null, null, null, null, null, null, commendation, improvement, completedDate, SurveyType.PreOp));
        },
        submitPostDonationSurvey: (id, treatment, convenience, facility, commendation, improvement, completedDate) => {
            return dispatch(DashActionCreators.submitSurvey(id, treatment, convenience, facility, null, null, null, null, null, null, commendation, improvement, completedDate, SurveyType.Surgery));
        },
        submitPostDonation30DaysSurvey: (id, surgeonCare, nurseCare, painCare, caretakerTreatment, financialBurden, donationCost, commendation, improvement, completedDate) => {
            return dispatch(DashActionCreators.submitSurvey(id, null, null, null, surgeonCare, nurseCare, painCare, caretakerTreatment, financialBurden, donationCost, commendation, improvement, completedDate, SurveyType.SurgeryPost30));
        },
        saveLogEntry: (id, dashRegistrationId, actionTaken, comments, isPinned) => {
            return dispatch(DashActionCreators.saveLogEntry(id, dashRegistrationId, actionTaken, comments, isPinned));
        },
        deleteLogEntry: (id) => {
            return dispatch(DashActionCreators.deleteLogEntry(id));
        },
        findForTransfer: (centerid, email, birthDate) => {
            return dispatch(DashActionCreators.findForDonorConnectTransfer(centerid, email, birthDate))
        },
        transferToExistingRegistration: (transferFromId, transferToId) => {
            return dispatch(DashActionCreators.transferDonorConnectToExistingRegistration(transferFromId, transferToId));
        },
        transferToCenter: (registrationId, centerId) => {
            return dispatch(DashActionCreators.transferDonorConnectToCenter(registrationId, centerId));
        },
        sendDonorInvite: (donorEmail) => {
            return dispatch(DashActionCreators.sendConfirmEmail(donorEmail));
        },
        getDuplicates: (registrationId) => {
            return dispatch(DashActionCreators.getDuplicates(registrationId));
        },
        getCenterContacts: (centerId) => {
            return dispatch(DashActionCreators.getCenterContacts(centerId));
        },
        downloadCenterContacts: (centerId) => {
            return dispatch(DashActionCreators.downloadCenterContacts(centerId));
        },
        onHoldStatusReasonChange: (id, onHoldStatusReason) => {
            return dispatch(DashActionCreators.onHoldStatusReasonChange(id, onHoldStatusReason));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(DonorConnect);
